import React, { useState } from 'react';

const ExampleVows = () => {
  const [selectedExample, setSelectedExample] = useState(null);
  
  const examples = [
    {
      title: "Traditional & Romantic",
      couple: "Sarah & Michael",
      excerpt: "From the moment I first saw you, I knew my life would never be the same. Today, I promise to be your faithful partner, to love you unconditionally, and to stand by your side through every chapter of our story...",
      fullVow: `From the moment I first saw you, I knew my life would never be the same. Your smile lit up the room, and your kindness touched my heart in ways I never thought possible.

Today, I promise to be your faithful partner, to love you unconditionally, and to stand by your side through every chapter of our story. I promise to celebrate your triumphs as if they were my own and to comfort you in times of sorrow.

I vow to be your best friend, your confidant, and your greatest supporter. I promise to laugh with you in times of joy, to hold you close in times of fear, and to grow with you in times of change.

With this ring, I give you my heart, my soul, and my forever. I choose you today, tomorrow, and for all the days of my life.`
    },
    {
      title: "Modern & Personal",
      couple: "Emma & James",
      excerpt: "I never believed in fairy tales until I met you. You turned my ordinary life into an extraordinary adventure, and today I promise to be your partner in all the adventures yet to come...",
      fullVow: `I never believed in fairy tales until I met you. You turned my ordinary life into an extraordinary adventure, and today I promise to be your partner in all the adventures yet to come.

I promise to make you coffee every morning, even when I'm grumpy. I promise to always save you the last slice of pizza and to never spoil the ending of your favorite shows.

But more importantly, I promise to love you fiercely, to support your dreams without hesitation, and to always be your safe place to land. I promise to grow old with you, to hold your hand through the hard times, and to dance with you in the kitchen on random Tuesday nights.

You are my best friend, my favorite person, and my forever love. Today, I choose you. Tomorrow, I'll choose you again. And every day after that, I'll keep choosing you.`
    }
  ];

  const closeLightbox = () => {
    setSelectedExample(null);
  };

  return (
    <>
      <div id="examples" className="mt-5 pt-5">
        <div className="text-center mb-4">
          <h2 className="commercial-heading mb-2">Example Vows</h2>
          <p className="commercial-subheading">See the beautiful vows we can help you create</p>
        </div>
        
        <div className="row g-4 justify-content-center">
          {examples.map((example, index) => (
            <div key={index} className="col-lg-5 col-md-6">
              <div className="glass-card example-card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => setSelectedExample(example)}>
                <div className="text-center mb-3">
                  <div className="example-icon mb-2">
                    <i className="bi bi-heart-fill" style={{ fontSize: '3rem', color: '#1e3a5f' }}></i>
                  </div>
                  <h3 className="example-name" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#5d3a3b', marginBottom: '0.5rem', fontFamily: "'Playfair Display', serif" }}>
                    {example.title}
                  </h3>
                  <p className="example-couple" style={{ fontSize: '1rem', color: '#8b5a5b', marginBottom: '1rem', fontStyle: 'italic' }}>
                    {example.couple}
                  </p>
                </div>
                
                <div className="example-preview" style={{ 
                  maxHeight: '200px', 
                  overflow: 'hidden',
                  marginBottom: '1rem',
                  padding: '1rem',
                  background: 'rgba(30, 58, 95, 0.03)',
                  borderRadius: '12px',
                  border: '2px solid rgba(30, 58, 95, 0.15)'
                }}>
                  <p style={{ 
                    color: '#5d3a3b', 
                    fontSize: '0.9rem', 
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: 6,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textAlign: 'left',
                    fontFamily: "'Lora', serif",
                    fontStyle: 'italic'
                  }}>
                    {example.excerpt}
                  </p>
                </div>
                
                <div className="text-center">
                  <button 
                    className="btn btn-secondary"
                    style={{ 
                      color: '#5d3a3b',
                      borderColor: 'rgba(30, 58, 95, 0.4)'
                    }}
                  >
                    <i className="bi bi-eye me-2"></i>
                    Read Full Vow
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedExample && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ 
            backgroundColor: 'rgba(30, 58, 95, 0.9)', 
            zIndex: 9999,
            backdropFilter: 'blur(5px)'
          }}
          onClick={closeLightbox}
        >
          <div 
            className="glass-card modal-scroll-hide m-3"
            style={{ 
              maxWidth: '700px', 
              maxHeight: '85vh', 
              overflowY: 'auto',
              overflowX: 'hidden',
              backgroundColor: 'rgba(255, 255, 255, 0.98)',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              padding: '2rem',
              borderRadius: '24px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
            }}
            onClick={e => e.stopPropagation()}
          >
            <style>{`
              .modal-scroll-hide::-webkit-scrollbar {
                display: none !important;
                width: 0 !important;
              }
              .modal-scroll-hide {
                scrollbar-width: none !important;
                -ms-overflow-style: none !important;
              }
            `}</style>
            <div className="d-flex justify-content-between align-items-start mb-4">
              <div>
                <h3 style={{ color: '#1e3a5f', fontFamily: "'Playfair Display', serif", marginBottom: '0.5rem', fontSize: '1.75rem' }}>{selectedExample.title}</h3>
                <p style={{ color: '#8b5a5b', fontStyle: 'italic', marginBottom: 0, fontSize: '1.1rem' }}>{selectedExample.couple}</p>
              </div>
              <button 
                className="btn" 
                onClick={closeLightbox}
                style={{ 
                  color: '#ffffff', 
                  fontSize: '1.25rem', 
                  padding: '0.25rem 0.5rem',
                  backgroundColor: '#1e3a5f',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  boxShadow: '0 2px 8px rgba(30, 58, 95, 0.3)',
                  flexShrink: 0
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
            
            <div style={{ 
              padding: '1.5rem',
              background: 'rgba(30, 58, 95, 0.03)',
              borderRadius: '16px',
              border: '2px solid rgba(30, 58, 95, 0.12)'
            }}>
              {selectedExample.fullVow.split('\n\n').map((paragraph, idx) => (
                <p key={idx} style={{ 
                  color: '#5d3a3b', 
                  lineHeight: '1.9',
                  marginBottom: idx === selectedExample.fullVow.split('\n\n').length - 1 ? 0 : '1.25rem',
                  fontFamily: "'Lora', serif",
                  fontStyle: 'italic',
                  fontSize: '1.05rem'
                }}>
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExampleVows;
